module.exports = new __parcel__URL__("work.bcd53feb.svg").toString();